<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-4">Registruotų naudotojų paieškos</h3>

    <paieska-registruoti-search
      class="mt-1 mb-1"
      :loading="loadingList"
      @search="searchRegistruoti"
    />

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :item-class="rowClass"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
      item-key="pai_id"
      :expanded.sync="expanded"
      single-expand
    >
      <template #[`item.pai_busena_pavadinimas`]="{ item }">
        <el-busena
          :busena="item.pai_busena_pavadinimas"
          :color="item.busenaColor"
        />
      </template>
      <template #[`item.pai_duomenu_naudojimo_tikslas`]="{ item }">
        <div class="text-cut-4">
          {{ item.pai_duomenu_naudojimo_tikslas }}
        </div>
      </template>
      <template #[`item.pai_teisinis_pagrindas`]="{ item }">
        <div class="text-cut-4">
          {{ item.pai_teisinis_pagrindas }}
        </div>
      </template>
      <template #[`item.pagrindas_bylos`]="{ item }">
        <el-byla
          v-for="byla in item.pagrindas_bylos"
          :key="byla.byl_id"
          :byla="byla"
          color="primary"
          with-name
        />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="table-actions">
          <v-icon
            dense
            :color="`${item.expandedResult ? 'primary' : ''}`"
            class="table-action mx-2"
            @click="viewExpandedResult(item)"
          >
            mdi-eye-check
          </v-icon>
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pt-4">
          <el-textarea
            readonly
            label="Paslaugos pavadinimas"
            v-model="item.pai_tipas_pavadinimas"
          />
          <el-textarea
            readonly
            label="Duomenų naudojimo tikslas"
            v-model="item.pai_duomenu_naudojimo_tikslas"
          />
        </td>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PaieskaRegistruotiSearch from './PaieskaRegistruotiSearch'
import rowClass from '../../mixins/rowClass'
import math from '../../mixins/math'

export default {
  name: 'PaieskaRegistruoti',
  components: { PaieskaRegistruotiSearch },
  mixins: [rowClass, math],
  data: () => ({
    pageloading: true,
    loading: false,
    paieskos: [],
    search: null,
    showList: false,
    loadingList: true,
    saugojimoLaikas: null,
    israsoLaikas: null,
    searchData: {},
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      sort: null,
      sortDesc: [],
      direction: 'asc',
    },
    itemsPerPageOptions: [10, 50, 100],
    paginationloading: false,
    expanded: [],
    expandedRow: null,
  }),
  computed: {
    ...mapGetters(['paieskaPavadinimas']),
    headers() {
      return [
        {
          text: 'Paieškos numeris',
          align: 'start',
          value: 'pai_numeris',
        },
        {
          text: 'Apimtis',
          align: 'start',
          value: 'pai_apimtis_pavadinimas',
        },
        {
          text: 'Paiešką užsakęs asmuo',
          align: 'start',
          value: 'pai_sukure',
          sortable: false,
        },
        {
          text: 'Paieška atlikta pagal',
          align: 'start',
          value: 'pai_atlikta_pagal',
          sortable: false,
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pai_busena_pavadinimas',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'pai_atnaujinimo_data',
        },
        {
          text: 'Paieškos užsakymo data',
          align: 'center',
          value: 'pai_sukurimo_data',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paieskos.map(item => {
        item.expandedResult = false
        item.canView = true

        item.pai_tipas_pavadinimas =
          this.paieskaPavadinimas[item.pai_tipas_kodas] ?? ''
        item.busenaColor = item.pai_busena === 'ivykdyta' ? 'green' : 'default'

        if (item.pai_busena === 'laukia_patvirtinimo') {
          item.canTikrinti = true
        }
        if (item.pai_busena === 'tikrinama') {
          item.canPatvirtinti = true
          item.canAtmesti = true
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    //
  },
  watch: {
    loading() {
      this.expanded = []
      this.expandedRow = null
    },
  },
  methods: {
    searchRegistruoti(searchData, silent = false) {
      this.searchData = searchData
      this.loadingList = !silent

      if (!silent) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: { ...searchData },
      }
      this.$axios
        .post(`paieska/registruotu-naudotoju`, data)
        .then(res => {
          this.paieskos = res.data.paieskos
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loadingList = false
          this.paginationloading = false
          this.showList = true
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loadingList) {
        this.updateList()
      }
    },
    updateList() {
      this.searchRegistruoti(this.searchData, true)
    },
    viewExpandedResult(item) {
      item.expandedResult = !item.expandedResult
      this.clearExpanded(item)
      this.expanded = []
      this.expandedRow = null
      if (item.expandedResult) {
        this.expanded = [item]
        this.expandedRow = item.pai_id
      }
    },
    clearExpanded(item) {
      this.paieskos.forEach(e => {
        if (e.pai_id != item.pai_id) {
          e.expandedResult = false
        }
      })
    },
    getActiveClass(item) {
      return item.pai_id === this.expandedRow ? 'row-active' : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
.disclaimer {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
